import React from "react";

// NOTE: The multilingual / AI translation system has been disabled.
// This file is kept as a compatibility shim so that components which still
// import `useLang` / `useT` continue to work without changes. All texts are
// rendered verbatim (Polish source).

const NOOP_CTX = {
    lang: "pl",
    t: (s) => s,
    lp: (p) => p || "/",
    switchLang: () => {},
};

export function LangProvider({ children }) {
    // No provider logic needed any more.
    return <>{children}</>;
}

export function useLang() {
    return NOOP_CTX;
}

export function useT() {
    return NOOP_CTX.t;
}
